export function cn (...args) {
  return args.filter(Boolean).join(' ')
}

export function mapEdgesToNodes (data) {
  if (!data.edges) return []
  return data.edges.map(edge => edge.node)
}

export function filterOutDocsWithoutSlugs ({ slug }) {
  return (slug || {}).current
}

export function getConcentrationUrl (academicYear, slug) {
  return `/concentration/${academicYear}/${slug.current || slug}/`
}

export function getInstructorUrl (slug) {
  return `/instructor/${slug.current || slug}/`
}

export function getStudentUrl (slug) {
  return `/student/${slug.current || slug}/`
}

export function getWorkUrl (academicYear, slug) {
  return `/work/${academicYear}/${slug.current || slug}/`
}

export function getBFAShowUrl (academicYear) {
  return `/bfa-show/${academicYear}/`
}

export function getSeniorShowUrl (academicYear) {
  return `/senior-show/${academicYear}/`
}

export function getOpenStudoioUrl (academicYear) {
  return `/open-studio/${academicYear}/`
}

export function getIndependentStudyUrl (academicYear, term, slug) {
  const t = term.toLowerCase();
  return `/independent-study/${academicYear}/${t}/${slug.current || slug}/`
}

export function getCourseUrl (academicYear, courseNumber, term, section) {
  const t = term.replace(/\s+/g, '-').toLowerCase();
  const n = courseNumber.toLowerCase();
  return `/course/${academicYear}/${t}/${n}/${section}/`
}

export function buildImageObj (source) {
  const imageObj = {
    asset: { _ref: source.asset._ref || source.asset._id }
  }
  if (source.crop) imageObj.crop = source.crop
  if (source.hotspot) imageObj.hotspot = source.hotspot
  return imageObj
}

export function buildRawImageObj (source) {
  const imageObj = {
    asset: { _ref: source.asset._ref || source.asset._id }
  }
  return imageObj
}

export function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}
